<template>
  <div>
    <v-btn
      :class="cssClass"
      :loading="loading"
      :disabled="disabled"
      @click="$emit('click')"
      :data-qa="dataQa">
      <div class="button-text">{{ $t(text) }}</div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "PrimaryButton",
  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pill: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      default: ''
    }
  },
  computed: {
    cssClass() {
      let cssClass = 'primary-button'
      cssClass = this.pill ? cssClass + ' pill' : cssClass
      cssClass = this.loading ? cssClass + ' loading' : cssClass
      return cssClass
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_i18n-mixins';
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.primary-button {
  background-color: var(--brand-color-secondary) !important;
  color: white;
  min-width: 103px !important;
  max-width: 200px !important;
  height: 48px !important;
  border-radius: 4px;
  box-shadow: 0px 0px 0px 0px;

  align-items: center;
  font-family: var(--primary-font-family);
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.003em;

  &:focus {
    box-shadow: 0px 0px 0px 3px rgba(var(--brand-color-secondary-rgb), 0.4);
  }

  &:active:focus{
    box-shadow: none !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.24);
  }

  &:active {
    background: rgba(255, 255, 255, 0.4);
  }
}

.pill {
  border-radius: 47px !important;
}

.loading {
  background-color: rgba(var(--brand-color-secondary-rgb), 0.6) !important;
}

.button-text {
  margin-right: 8px;
  margin-left: 8px;
}
</style>
